import React from 'react';
import { Redirect, Route, Switch } from 'react-router';
import PaymentProfile from 'modules/PaymentProfile';
import { BillingAndPayments } from 'modules/BillingAndPayments';
import MyBills from 'modules/MyBills';
import { Unauthorized } from 'pages/ErrorPages';
import AuthRoute from 'components/AuthRoute/AuthRoute';
import Cancellation from 'modules/Cancellation';

export enum ERoutePath {
    Home = '/',
    PaymentProfile = '/paymentProfile',
    MyBills = '/myBills',
    BillingAndPayments = '/billingAndPayments',
    Cancellation = '/cancellation',
    ProductManagement = '/productManagement',
    EditPaymentDetails = '/product/paymentProfile',
    RequestCancellation = '/product/cancellation',
    Unauthorized = '/unauthorized',
}

const Routes: React.FC = () => {
    return (
        <Switch>
            <AuthRoute path={ERoutePath.PaymentProfile} children={<PaymentProfile />} />
            <AuthRoute path={ERoutePath.MyBills} children={<MyBills />} />
            <AuthRoute path={ERoutePath.BillingAndPayments} children={<BillingAndPayments />} />
            <Route path={ERoutePath.Cancellation} children={<Cancellation />} />
            <Route path={ERoutePath.Unauthorized} children={<Unauthorized />} />
            <Redirect exact from="/" to={ERoutePath.BillingAndPayments} />
            {/*<Route path="" component={PageNotFound} />*/}
        </Switch>
    );
};

export default Routes;
